import { render, staticRenderFns } from "./Sent.vue?vue&type=template&id=4b134613&scoped=true&lang=pug"
import script from "./Sent.vue?vue&type=script&lang=js"
export * from "./Sent.vue?vue&type=script&lang=js"
import style0 from "./Sent.vue?vue&type=style&index=0&id=4b134613&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b134613",
  null
  
)

export default component.exports